import React, { useContext, useState } from 'react'
import { Edit, Delete, Save, Cancel } from '@material-ui/icons'
import FeatherIcon from 'feather-icons-react'
import {
  Row,
  Button,
  ButtonToolbar,
  DropdownButton,
  Dropdown,
  Container,
  Form,
} from 'react-bootstrap'
import { printData } from '../Action'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'

const PrintButton = (props) => {
  const designContext = useContext(DesignContext)
  const { uischema } = props
  const {
    jsonForm,
    searchData,
    setFormData,
    setComponentPropsData,
    tableRefresh,
    setTableRefresh,
    tabParamActive,
    elementAction,
    getCurrentUi,
    currentSearch,
    isUiChanged,
    setIsUiChanged,
    setFieldFormData,
    callback,
    isInputSearch,
    employeeList,
    getEmployee,
    setSearchData,
    setDatasourceValue,
  } = designContext
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const uiChanged = objectPath(isUiChanged)
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  const isRefreshTable =
    uiChanged.get('isRefreshTable') ||
    objectPath.get(componentPropsData, 'isRefreshTable')
  const designerData = objectPath.get(componentPropsData, 'data')
  const action = uischema.tableAction?.action || []
  const printAction = action.find(({ name }) => name === 'print')
  const rowSelection =
    objectPath.get(isUiChanged, ['tableSelection', uischema.key]) || []
  const formData = jsonForm.formData

  return (
    <ButtonToolbar>
      <DropdownButton
        title={
          <>
            <FeatherIcon size="14" icon="printer" className="mr-1" />
            {printAction?.buttonText ?? 'ปริ้นท์'}
          </>
        }
        variant={'outline-info'}
        id={`dropdown-variants-info`}
        key="info"
        className="text-capitalize"
      >
        {(printAction?.printList || []).map((print, index) => {
          if (print?.printButton) {
            return (
              <Dropdown.Item
                key={`print-${index + 1}`}
                eventKey={`print-${index + 1}`}
                onClick={() =>
                  printData(
                    print,
                    {
                      dataSelected: rowSelection,
                      datasourceValue,
                      formData,
                      designerData,
                    },
                    true
                  )
                }
              >
                {print.printName}
              </Dropdown.Item>
            )
          }
        })}
      </DropdownButton>
    </ButtonToolbar>
  )
}

export default PrintButton
